import React from "react";
import {Link} from "gatsby";
import {stripPrefix} from "../../function/functions";
const FooterMenu = ({menu,name}) => {
    // console.log("menu" , name , menu)

  return (
      <div className={`wrapMenu style-2 menu-${name}`}>
          <ul>
              {
                  menu?.map((item, index) => {
                      // console.log("menu" , item.connectedNode.node?.removeSlug?.false )
                      return (
                          <li key={`${name}_${index}`}>
                              <Link to={stripPrefix(item.path)}>
                                  {item.label}
                              </Link>
                          </li>
                      )
                  })
              }
          </ul>
      </div>
  )
}
export default FooterMenu